interface CriticalProject {
  id: number | string
  name: string
  issue: string
  status: string
  budgetAtRisk: string
  owner: string
}

interface CriticalProjectsListProps {
  projects: CriticalProject[]
  onViewAll?: () => void
  onProjectClick?: (project: CriticalProject) => void
}

export function CriticalProjectsList({ projects, onViewAll, onProjectClick }: CriticalProjectsListProps) {
  return (
    <div className="bg-white p-6 rounded-xl border-2 border-[#bcccdc] shadow-lg">
      <div className="flex items-center justify-between mb-4 pb-3 border-b-2 border-[#f0f4f8]">
        <h2 className="text-lg text-[#102a43]">Critical Projects Requiring Immediate Attention</h2>
        {onViewAll && (
          <button
            onClick={onViewAll}
            className="text-[#486581] hover:text-[#102a43] text-sm font-medium"
          >
            View All Projects →
          </button>
        )}
      </div>
      {projects.length === 0 ? (
        <div className="text-center py-8 text-[#486581]">
          <svg className="w-12 h-12 mx-auto mb-4 text-[#829ab1]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <p className="text-sm font-medium">No critical projects requiring immediate attention.</p>
          <p className="text-xs text-[#829ab1] mt-1">All projects are on track.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {projects.map((project) => (
          <div
            key={project.id}
            onClick={() => onProjectClick?.(project)}
            className={`flex items-center gap-4 p-4 bg-[#f0f4f8] border-2 border-[#bcccdc] rounded-lg hover:bg-white hover:border-[#829ab1] hover:shadow-md transition-all ${
              onProjectClick ? 'cursor-pointer' : ''
            }`}
          >
            <div className="p-2 bg-red-100 rounded-lg">
              <svg className="w-5 h-5 flex-shrink-0 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
            </div>
            <div className="flex-1">
              <div className="flex items-center gap-3 mb-1">
                <h3 className="font-medium text-[#102a43]">{project.name}</h3>
                <span className="px-2 py-0.5 rounded text-xs bg-red-100 text-red-700 border border-red-300 font-medium">
                  {project.status}
                </span>
              </div>
              <p className="text-sm text-[#486581]">{project.issue}</p>
            </div>
            <div className="text-right">
              <div className="text-sm mb-1 text-[#829ab1]">
                Owner: <span className="text-[#486581] font-medium">{project.owner}</span>
              </div>
              <div className="text-sm text-red-600 font-medium">{project.budgetAtRisk} at risk</div>
            </div>
          </div>
        ))}
        </div>
      )}
    </div>
  )
}

